export const GREETING_AUDIO = {
  new: require("../assets/audio/en/tiffany/start-story.mp3"),
  continue: require("../assets/audio/en/tiffany/continue-story.mp3"),
} as const;

export type EntryGreeting = keyof typeof GREETING_AUDIO;
